import DataListItem from './DataListItem';

export default DataListItem;
